import {
  fromCondition,
  pipe,
  tapLeft,
  tapRight,
  left,
  right,
  type Effect,
  flatMap,
  tapRightSpread,
} from "@otto-ec/assets-core-utils/nano-effect";
import type { NavigationState } from "@otto-ec/global-resources/navigation";
import { stack } from "../stack/stack.global.svelte.js";
import {
  scopeInfo,
  statePropConfig,
  statePropId,
  statePropOnLoad,
  statePropStack,
  type SheetHistoryState,
  type SheetNavScope,
} from "./scope.js";
import { navScope } from "./scope.js";
import { sheetTagName } from "../utils/consts.js";
import { findInstance } from "../stack/stack.utils.js";
import { sheetProps } from "../utils/props.js";
import type { OcSheetV1Props } from "../SheetV1.types.g.js";

const log = /*           */ navScope.scope("stack");

/**
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 */
export const shouldIncommingSheetIdbeProcessed = (
  currentId: string | null,
  newSheetId: string | null,
): Effect<string, null> => {
  /*                                                                                     */
  /*                                                                  */
  if (!newSheetId) {
    if (import.meta.env.DEV) log.info("no new sheet id, skip pushing to history");
    return left(null);
  }

  /*                                                                          */
  if (currentId === newSheetId) {
    if (import.meta.env.DEV)
      log.info("sheet id", newSheetId, "is already in the hash, skip pushing");
    return left(null);
  }

  /*                                                             */
  if (import.meta.env.DEV) log.info("new sheet id", newSheetId, "pushing to history");
  return right(newSheetId);
};

/**
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 */
export const isSheetNavFrameAlreadyPrepared = (
  scope: SheetNavScope,
  newSheetId: string,
  state = scope.state(),
): Effect<[SheetNavScope, string], [SheetNavScope, string]> =>
  fromCondition(
    /*                                                                   */
    (state.get(statePropOnLoad) && !state.get(statePropId)) ||
      /*                                                 */
      state.get(statePropId) === newSheetId,
    /*                                                */
    [scope, newSheetId],
    [scope, newSheetId],
  );

export const updateSheetPropsInScope = (state: NavigationState<SheetHistoryState>): void => {
  const instance = findInstance(stack.current);
  if (instance) {
    /*                                          */
    const props = Object.fromEntries(sheetProps.map((p) => [p, instance[p]])) as OcSheetV1Props;
    if (import.meta.env.DEV) log.info("open sheet props changed", props, history.length);
    state.set(statePropConfig, props);
  }
};

/**
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 */
export const updateCurrentHistoryEntryWithSheetId = (
  scope: SheetNavScope,
  newSheetId: string,
): void => {
  if (import.meta.env.DEV) log.info("updating state with new sheet id", newSheetId, history.length);

  const state = scope.state();
  state.set(statePropId, newSheetId);
  state.set(statePropStack, [...stack.prev]);

  updateSheetPropsInScope(state);
  scope.replace(scopeInfo);
};

/**
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 */
export const pushNewHistoryEntryWithSheetId = ([scope, newSheetId]: [
  scope: SheetNavScope,
  newSheetId: string,
]): void => {
  if (import.meta.env.DEV)
    log.info("pushing new history entry with new sheet id", newSheetId, history.length);

  scope.hash().set(sheetTagName, newSheetId);
  const state = scope.state<SheetHistoryState>({
    [statePropStack]: [...stack.prev],
    [statePropId]: newSheetId,
  });

  updateSheetPropsInScope(state);
  scope.push(scopeInfo);
};

/**
 *
 *
 *
 *
 */
export const initHistoryHandling: (scope: SheetNavScope) => void = (scope) => {
  if (import.meta.env.DEV) log.info("init history updater integration", history.length);

  $effect(() => {
    if (import.meta.env.DEV) log.info("sheet stack changed", history.length);

    const currentId = scope.hash().get(sheetTagName);
    if (currentId === stack.current) {
      if (import.meta.env.DEV) log.info("already handled by fragment handler");
      return;
    }

    pipe(
      /*                                                                                              */
      /*                                                                              */
      /*                                                                              */

      /*                                                     */
      /*                                                             */
      fromCondition(stack.isPopping, stack.popLength, stack.current),

      /*                       */
      tapRight((entriesToRewind) => {
        /*                                                                       */
        if (entriesToRewind < 1) {
          if (import.meta.env.DEV) log.info("no entries to rewind, skip history rewind");
          return;
        }

        /*                                                                       */
        /*                                                              */
        if (!currentId) {
          if (import.meta.env.DEV) log.info("no sheet id in hash, skip history rewind");
          return;
        }

        /*                                               */
        scope.go(-entriesToRewind, scopeInfo);
      }),

      /*                                                                                     */
      tapLeft((newSheetIdOrNull) =>
        pipe(
          shouldIncommingSheetIdbeProcessed(currentId, newSheetIdOrNull),

          flatMap((newSheetId) =>
            pipe(
              isSheetNavFrameAlreadyPrepared(scope, newSheetId),
              /*                                                          */
              tapRightSpread(updateCurrentHistoryEntryWithSheetId),
              /*                                                     */
              tapLeft(pushNewHistoryEntryWithSheetId),
            ),
          ),
        ),
      ),
    );
  });
};
